module.exports = __webpack_public_path__ + "assets/img/veg_right.2ba1e58b.png";